import Icon from '../Icon.vue'

Icon.register({
  'print': {
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M18.75 12.375c.313 0 .578.11.797.328.219.219.328.485.328.797 0 .313-.11.578-.328.797a1.085 1.085 0 01-.797.328c-.313 0-.578-.11-.797-.328a1.084 1.084 0 01-.328-.797c0-.313.11-.578.328-.797.219-.219.485-.328.797-.328zm1.5-4.125c1.031 0 1.914.367 2.648 1.102C23.633 10.086 24 10.969 24 12v6a.73.73 0 01-.211.539.73.73 0 01-.54.211h-3v4.5a.73.73 0 01-.21.539.73.73 0 01-.54.21H4.5a.73.73 0 01-.54-.21.73.73 0 01-.21-.54V18.75h-3a.73.73 0 01-.54-.211A.73.73 0 010 18v-6c0-1.031.367-1.914 1.102-2.648.734-.735 1.617-1.102 2.648-1.102V1.5c0-.406.14-.758.422-1.055.281-.297.61-.445.984-.445h10.407a2.17 2.17 0 011.593.656l2.438 2.438c.437.437.656.968.656 1.593V8.25zM6 2.25v6h12v-3h-2.25a.73.73 0 01-.54-.211A.73.73 0 0115 4.5V2.25H6zm12 19.5v-3H6v3h12zm3.75-5.25V12c0-.406-.148-.758-.445-1.055a1.441 1.441 0 00-1.055-.445H3.75c-.406 0-.758.148-1.055.445A1.442 1.442 0 002.25 12v4.5h19.5z'
      }
    ]
  }
})
